module.exports = __webpack_public_path__ + "allow-transform_03.png?7abf7a27ef111f114b31e2c324c0a89e";


//////////////////
// WEBPACK FOOTER
// ./static/assets/allow-transform_03.png
// module id = 36
// module chunks = 0